export default "__VITE_ASSET__DABMAf6W__"